import { Button, Modal, Stack, Text, Textarea } from "@assetwatch/ui";
import { useEffect, useState } from "react";
import { displayWorkOrderNumber } from "../snowflakes/work-orders/presentation";

export function CancelWorkOrderModal({
  open,
  number,
  error,
  isPending,
  onOpenChange,
  onCancel,
}: {
  open: boolean;
  number: string;
  error: string | null;
  isPending: boolean;
  onOpenChange: (open: boolean) => void;
  onCancel: (reason: string) => Promise<void>;
}) {
  const [reason, setReason] = useState("");
  const [showValidationError, setShowValidationError] = useState(false);

  useEffect(() => {
    if (open) {
      setReason("");
      setShowValidationError(false);
    }
  }, [open]);

  async function submit() {
    if (!reason.trim()) {
      setShowValidationError(true);
      return;
    }
    await onCancel(reason.trim());
    onOpenChange(false);
  }

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={`Cancel ${displayWorkOrderNumber(number)}`}
      size="md"
    >
      <Stack gap={16}>
        <Text>
          Canceling this Work Order stops execution and declines its linked
          Approved Request.
        </Text>
        <Textarea
          label="Cancellation reason"
          aria-label="Cancellation reason"
          value={reason}
          onChange={(event) => {
            setReason(event.target.value);
            setShowValidationError(false);
          }}
        />
        {showValidationError ? (
          <Text tone="negative">A cancellation reason is required.</Text>
        ) : error ? (
          <Text tone="negative">{error}</Text>
        ) : null}
        <div className="flex justify-end gap-(--spacing-8)">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            disabled={isPending}
            loading={isPending}
            loadingText="Canceling"
            onClick={() => void submit().catch(() => undefined)}
          >
            Cancel Work Order
          </Button>
        </div>
      </Stack>
    </Modal>
  );
}
